module.exports = __webpack_public_path__ + "img/五矿地产.c0d9d820.png";